export default "__VITE_ASSET__Bs966Q42__"